import React, { useState, useEffect } from "react";
import {
  colorBlack,
  colorWhite,
  primaryColor,
} from "../../../../../utility/constants/colorManager";
import { CustomButton } from "../../../../components/main_comps/custom_button";
import { CustomInput } from "../../../../components/main_comps/custom_input/CustomInput";
import { useSnackbar } from "notistack";
import { businessTypeDropdown } from "../../../../../data/freezedData";
import { checkObjHasAllValue } from "../../../../components/ui_comps/ComissionContainer";
import { useDispatch } from "react-redux";
import { addClientData } from "../../../../../data/redux/slice/clientOnboardDataSlice";
import RowButton from "../../../../components/ui_comps/RowButton";
import { fontSize } from "@mui/system";
import { ApiRequestPost } from "../../../../../data/network/services/ApiRequestPost";
import {
  STATUS_CODE_200,
  SUCCESS,
} from "../../../../../utility/constants/valueConstants";
import { CustomLoader } from "../../../../components/main_comps/custom_loader";

function ClientBankDetails({ onClickNext, onClickBack, reduxData }) {
  const [businessName, setBusinessName] = useState("");
  const [businessType, setBusinessType] = useState("");
  const [nameAsPerBank, setNameAsPerBank] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [changeColor, setChangeColor] = useState(false);
  const [remitterAccountValidate, setRemitterAccountValidate] = useState(false);
  const [settlementAccountValidate, setSettlementAccountValidate] =
    useState(false);
  const [remitterAccountNumber, setRemitterAccountNumber] = useState("");
  const [remitterNameAsPerBank, setRemitterNameAsPerBank] = useState("");
  const [remitterIfscCode, setRemitterIfscCode] = useState("");
  const [loading, setLoading] = useState(false);

  //const [changediv, setChangediv] = useState(false);

  const inputStyle = {
    backgroundColor: "#F3F3F3",
    alignSelf: "center",
    height: 50,
    width: "100%",
    boxShadow: "none",
    outline: "none",
    paddingLeft: 10,
    borderRadius: 5,
    boxSizing: "border-box",
  };
  const containerStyle = {
    padding: 0,
    height: 50,
    marginTop: 20,
  };

  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  const validateAccountWithPennyDrop = (
    accNo,
    ifsc,
    benificiaryName,
    settlement = false
  ) => {
    if (!accNo && !ifsc && !benificiaryName) {
      enqueueSnackbar("Please enter all the account details", {
        variant: "error",
      });
      return;
    }

    if (accNo.length < 9) {
      enqueueSnackbar("Please enter valid account number", {
        variant: "error",
      });
      return;
    }

    if (ifsc.length != 11) {
      enqueueSnackbar("Please enter valid ifsc code", {
        variant: "error",
      });
      return;
    }

    setLoading(true);
    ApiRequestPost.checkPennyDropAccount({
      accNo,
      ifsc,
      benificiaryName,
      address: reduxData?.address,
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          if (res?.data?.status === SUCCESS) {
            if (settlement) {
              setSettlementAccountValidate(true);
            } else {
              setRemitterAccountValidate(true);
            }
            enqueueSnackbar("Account verified successfully", {
              variant: "success",
            });
          } else {
            enqueueSnackbar("Account verification failed", {
              variant: "error",
            });
          }
        } else {
          enqueueSnackbar(res.message, {
            variant: "error",
          });
        }
      })
      .catch((e) => {})
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (
      reduxData?.businessName &&
      reduxData?.businessType &&
      reduxData?.nameAsPerBank &&
      reduxData?.bankAccountNumber &&
      reduxData?.bankIfscCode
    ) {
      setBusinessName(reduxData?.businessName);
      setBusinessType(reduxData?.businessType);
      setNameAsPerBank(reduxData?.nameAsPerBank);
      setAccountNumber(reduxData?.bankAccountNumber);
      setIfscCode(reduxData?.bankIfscCode);
    }
  }, [reduxData]);

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <CustomInput
        value={businessName}
        onChange={(data) => setBusinessName(data)}
        inputcomponentStyles={{ ...inputStyle }}
        placeholder="Business Name "
        validator="companyName"
        type="input"
        inputStyles={{
          ...containerStyle,
          marginBottom: "20px",
        }}
      />
      <CustomInput
        value={businessType}
        onChange={(data) => setBusinessType(data)}
        inputcomponentStyles={{ ...inputStyle }}
        placeholder="Last Name"
        validator="name"
        type="select"
        dropdownStyle={{
          ...inputStyle,
        }}
        inputStyles={{
          backgroundColor: "transparent",
          border: "none",
          boxShadow: "none",
          width: "100%",
        }}
        options={businessTypeDropdown}
      />

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "20px",
          borderRadius: "6px",
          backgroundColor: " #F3F3F3",
          textAlign: "center",
          borderRadius: "6px",
          // gap: "20px",
        }}
      >
        <div
          style={{
            padding: "15px 25px 15px 25px",
            textAlign: "center",
            fontWeight: "400",
            width: "50%",
            fontSize: "14px",
            borderRadius: "6px",
            backgroundColor: changeColor ? "#F3F3F3" : "#FFD596",
            cursor: "pointer",
          }}
          onClick={() => setChangeColor(false)}
        >
          Remitter Account
        </div>
        <div
          style={{
            padding: "15px 25px 15px 25px",
            textAlign: "center",
            fontWeight: "400",
            width: "50%",
            fontSize: "14px",
            borderRadius: "6px",
            backgroundColor: changeColor ? "#FFD596" : "#F3F3F3",
            cursor: "pointer",
          }}
          onClick={() => setChangeColor(true)}
        >
          Settlement Account
        </div>
      </div>

      {changeColor ? (
        <div>
          <CustomInput
            value={nameAsPerBank}
            onChange={(data) => setNameAsPerBank(data)}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="Name as per bank"
            type="input"
            inputStyles={{
              ...containerStyle,
              marginTop: 20,
            }}
          />
          <CustomInput
            value={accountNumber}
            onChange={(data) => setAccountNumber(data)}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="Bank account number"
            validator="accountNumber"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
          />
          <CustomInput
            value={ifscCode}
            onChange={(data) => setIfscCode(data)}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="Bank IFSC code"
            validator="ifscCode"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
          />

          <div style={{ marginTop: "10px" }}>
            {loading ? (
              <CustomLoader />
            ) : (
              <p
                style={{
                  fontSize: 14,
                  color: settlementAccountValidate ? "#009152" : "#001777",
                  cursor: settlementAccountValidate ? "not-allowed" : "pointer",
                  fontWeight: "500",
                }}
                onClick={() => {
                  if (!settlementAccountValidate) {
                    validateAccountWithPennyDrop(
                      accountNumber,
                      ifscCode,
                      nameAsPerBank,
                      true
                    );
                  }
                }}
              >
                {settlementAccountValidate ? "Verified" : "Validate"}
              </p>
            )}
          </div>
        </div>
      ) : (
        <div>
          <CustomInput
            value={remitterNameAsPerBank}
            onChange={(data) => setRemitterNameAsPerBank(data)}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="Name as per bank"
            type="input"
            inputStyles={{
              ...containerStyle,
              marginTop: 20,
            }}
          />
          <CustomInput
            value={remitterAccountNumber}
            onChange={(data) => setRemitterAccountNumber(data)}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="Bank account number"
            validator="accountNumber"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
          />
          <CustomInput
            value={remitterIfscCode}
            onChange={(data) => setRemitterIfscCode(data)}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="Bank IFSC code"
            validator="ifscCode"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
          />

          <div style={{ marginTop: "10px" }}>
            {loading ? (
              <CustomLoader />
            ) : (
              <p
                style={{
                  fontSize: 14,
                  color: remitterAccountValidate ? "#009152" : "#001777",
                  cursor: remitterAccountValidate ? "not-allowed" : "pointer",
                  fontWeight: "500",
                  marginTop: "10px",
                }}
                onClick={() => {
                  if (!remitterAccountValidate) {
                    validateAccountWithPennyDrop(
                      remitterAccountNumber,
                      remitterIfscCode,
                      remitterNameAsPerBank,
                      false
                    );
                  }
                }}
              >
                {remitterAccountValidate ? "Verified" : "Validate"}
              </p>
            )}
          </div>
        </div>
      )}

      <RowButton
        onClickBack={onClickBack}
        onClickNext={() => {
          if (!remitterAccountValidate || !settlementAccountValidate) {
            enqueueSnackbar("Please add a remitter account", {
              variant: "error",
            });

            return;
          }

          if (
            checkObjHasAllValue({
              businessName,
              businessType,
              nameAsPerBank,
              accountNumber,
              ifscCode,
              remitterAccountNumber,
              remitterIfscCode,
              remitterNameAsPerBank,
            })
          ) {
            onClickNext({
              businessName,
              businessType,
              nameAsPerBank,
              bankAccountNumber: accountNumber,
              bankIfscCode: ifscCode,
              remitterAccountNumber,
              remitterIfscCode,
              remitterNameAsPerBank,
            });
          } else {
            enqueueSnackbar("Please fill all the fields", {
              variant: "error",
            });
          }
        }}
      />
    </div>
  );
}

export default ClientBankDetails;
